import Components from "slotworks/components/components";
import PromptContent from "slotworks/components/prompt/prompt-content";
import Layers from "slotworks/graphics/layers/layers";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";

export function HomeCommand(homeURL: string, onSessionClose: Function) {
    return new Contract<boolean>((resolve) => {

        const prompt = new PromptContent(["yes_no"], Infinity, Layers.Alerts);

        prompt.setText("body", Services.translations.get("gen.cex"));

        prompt.addContinueButton();
        prompt.addButton("no", () => {
            prompt.hide().execute();
            resolve(false);
        });

        Components.prompt.showPrompt(prompt).then(() => {
            if (onSessionClose) {
                onSessionClose();
            }

            if (homeURL === "close") {
                window.close();
            } else {
                window.open(homeURL, "_self");
            }

            resolve(true);
        });
    });

}
